import { weddingConfig } from '@/data/weddingConfig';
import ScrollReveal from '@/components/feature/ScrollReveal';

export default function ImportantInfo() {
  const visibleItems = weddingConfig.importantInformation.filter((item) => item.visible);

  if (visibleItems.length === 0) return null;

  return (
    <section className="relative w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-2xl px-6">
        <ScrollReveal>
          <div className="text-center">
            <p className="micro-label mb-5 text-foreground-500">Información importante</p>
            <div className="mx-auto h-px w-16 bg-primary-300" />
          </div>
        </ScrollReveal>

        <div className="mt-12 md:mt-14">
          {visibleItems.map((item, i) => (
            <ScrollReveal key={item.title} delay={i < 4 ? i + 1 : 4}>
              <div
                className={`flex items-start gap-5 py-6 md:py-7 ${
                  i < visibleItems.length - 1 ? 'border-b border-background-300/50' : ''
                }`}
              >
                <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rotate-45 bg-primary-400" />
                <div>
                  <h3 className="micro-label mb-2 text-foreground-700">{item.title}</h3>
                  <p className="font-body text-sm leading-relaxed text-foreground-500 sm:text-base">
                    {item.description}
                  </p>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}